import { savePDF } from '@progress/kendo-react-pdf';
import './PDFStyles.css'

class DocService {
  createPdf = (html) => {
    savePDF(html, { 
      paperSize: 'A4',
      fileName: 'attestation.pdf',
      landscape: true,
      scale: 0.6,
      margin: 3
    })
  }
}

const Doc = new DocService();
export default Doc;